import { render, staticRenderFns } from "./saved-query-source-card.vue?vue&type=template&id=85cd589c"
import script from "./saved-query-source-card.vue?vue&type=script&lang=js"
export * from "./saved-query-source-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports